import React, { useEffect } from "react";

const HubspotForm = () => {
  useEffect(() => {
    // El script para cargar el formulario de HubSpot
    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.type = "text/javascript";
    script.charset = "utf-8";

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "46247220",
          event: "form_MiSIM",
          formId: "be886c63-ebac-4ac1-b75f-c49ea62e872b",
          target: "#hubspotForm",
        });
      }
    };

    document.body.appendChild(script);

    // Limpieza: elimina el script cuando el componente se desmonte
    return () => {
      // Comprueba si el script existe en el body antes de intentar eliminarlo
      const existingScript = document.querySelector(
        'script[src="//js.hsforms.net/forms/embed/v2.js"]'
      );
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <>
      {/* Los estilos CSS se inyectan directamente aquí para evitar errores de compilación
        y mantener el componente autocontenido.
      */}
      <style>
        {`
          
          #hubspotForm .submitted-message {
            /* Aquí puedes cambiar el fondo y el color del texto a lo que necesites */
            background-color: #0a2342 !important; /* Tu color de fondo (sidom-blue) */
            color: #ffffff !important;           /* Tu color de texto (blanco) */
            
            /* Otros estilos para que se vea genial */
            border-radius: 1rem !important;
            padding: 3rem !important;
            text-align: center !important;
            margin-top: 1.5rem; /* Añade un espacio superior para separarlo del formulario */
            border: 1px solid #ffffff50; /* Un borde sutil para destacar */
          }

          /* A veces, el mensaje tiene un párrafo <p> adentro que también tiene sus propios
            estilos por defecto. Con esto nos aseguramos de que también sea blanco.
          */
          #hubspotForm .submitted-message p {
            color: #ffffff !important;
            margin: 0;
            font-size: 32px;
          }

          /*
            Opcional: HubSpot a veces añade un ícono de "check".
            Puedes ocultarlo si no encaja con tu diseño.
          */
          #hubspotForm .submitted-message .hs-success-icon {
            display: none;
          }
        `}
      </style>

      <section className="flex w-full items-center justify-center">
        <div className="w-full max-w-[800px] rounded-3xl bg-gradient-to-b from-sidom-orange via-sidom-blue via-50% to-sidom-blue to-40% p-4 py-20 sm:px-8 lg:px-16">
          <div className="flex w-full items-center justify-center">
            {/* El formulario de HubSpot se renderizará aquí */}
            <div id="hubspotForm" />
          </div>
        </div>
      </section>
    </>
  );
};

export default HubspotForm;
